<template>
    <div style="height:100%;"> 
        <title>寄件方信息管理</title>
        <div class="mainPart">
            <!--S 公用头部切换-->
            <!-- <CompanyTab :active="currentTit"></CompanyTab> -->
            <!--E 公用头部切换-->
            <!-- S头部搜索区域 -->
            <el-form :inline="true" :model="searchClsForm" class="searchForm">
                <el-form-item label="关键词">
                    <el-input v-model="searchClsForm.keywords" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model="searchClsForm.sendermob" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getSenderinfoList">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain @click="getShowDlog('add','',1)">新增</el-button>
                </el-form-item>
            </el-form>
            <!-- E头部搜索区域 -->
            <div class="gsListTable individualiz"> 
                <el-form :model="searchClsForm" inline size="medium">
                    <el-form-item class="borderline">
                        <em class="greyColor">状态</em>
                        <el-checkbox-group v-model="searchClsForm.status" @change="purposeUpdate">
                            <el-checkbox label="1">启用</el-checkbox>
                            <el-checkbox label="0">禁用</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item class="borderline borderNone">
                        <em class="greyColor"></em>
                        <el-checkbox v-model="searchClsForm.bdefault" @change="getSenderinfoList">默认选项</el-checkbox>
                    </el-form-item>
                </el-form>
                <!-- S 分类列表 scope.row.start-->
                <el-table class="comTable lev1Table" ref="lev1Table" :data="senderinfoList" border :max-height="tableHeight" v-loading="vloading">
                    <el-table-column label="序号" type="index"></el-table-column>
                    <el-table-column label="公司名称" min-width="150">
                        <template slot-scope="scope">
                            <p class="textFl" :title="scope.row.cmpyname">
                                <el-tag v-if="scope.row.bdefault == 1" effect="dark" title="默认寄件方">默认</el-tag>
                                {{ scope.row.cmpyname || '--' }}  
                            </p>
                        </template>
                    </el-table-column>  
                    <el-table-column label="寄件人" prop="sendername" sortable min-width="100">
                        <template slot-scope="scope">{{ scope.row.sendername || '--' }}</template>
                    </el-table-column>   
                    <el-table-column label="联系方式" prop="sendermob" sortable min-width="150">
                        <template slot-scope="scope">
                            <p v-if="scope.row.sendermob">{{ scope.row.sendermob }}</p>
                            <span v-if="scope.row.sendertel">{{ scope.row.sendertel }}</span>
                            <span v-if="!scope.row.sendermob && !scope.row.sendertel">--</span>
                        </template>
                    </el-table-column> 
                    <el-table-column label="详细地址" min-width="200">
                        <template slot-scope="scope">
                            <p>{{ scope.row.province }} {{ scope.row.city }} {{ scope.row.district }}</p>
                            <small class="greyColor">{{ scope.row.addrdet }}</small>
                        </template>
                    </el-table-column> 
                    <el-table-column label="状态" prop="status" sortable min-width="100">
                        <template slot-scope="scope">
                            <el-switch :value="scope.row.status ? true :false" @change="updSenderinfoStatus(scope.row,scope.row.status)" :width="45" class="isSwitch" :active-text="scope.row.status?'启':'禁'"></el-switch>
                        </template>
                    </el-table-column> 
                    <el-table-column label="备注" min-width="200">
                        <template slot-scope="scope">
                            <p class="textHidenP">
                                <span :title="scope.row.memo" class="textHiden">{{ scope.row.memo || '--' }}</span>
                            </p>
                        </template>
                    </el-table-column>      
                    <el-table-column label="操作" width="100" fixed="right">
                        <template slot-scope="scope">
                            <div class="handle">
                                <span @click="getShowDlog('detail',scope.row.id,scope.row.status)" class="detailA" title="详情"><i class="icondetails"></i></span>
                                <span @click="getShowDlog('edit',scope.row.id,scope.row.status)" title="配置"><i class="iconedit"></i></span>
                            </div>
                        </template>
                    </el-table-column>
                    <template slot="empty" v-if="vloading">
                        <div :class="{noData:vloading}"></div>
                    </template>
                    <template slot="empty" v-else>
                      <div class="noData"><span>暂无数据</span></div>
                    </template>
                </el-table>
                <!-- E 分类列表 -->
            </div>
            <!-- S 分页 -->
            <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
            <!-- E 分页 -->
        </div>
        <SenderOperate :addSenderDlog="addSenderDlog" :operate="operate" :senderId="senderId" :senderStatus="senderStatus" @closeChild="getCloseDlog"></SenderOperate>
    </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
    name:'SenderInfo',
    //  *********************************************************************组件
    components: {
        CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
        Page: resolve => require(["@/components/common/Page.vue"],resolve),
        SenderOperate: resolve => require(["@/components/ManageFolder/SenderOperate.vue"],resolve)
    },
    //   *********************************************************************变量
    data() {
        return {
            vloading:false,//加载中
            currentTit:4, //当前选中菜单
            searchClsForm: {
                keywords: '',
                status:[], //状态
                sendermob:'',//手机号码号
                bdefault:'',//是否为默认选项
            }, 
            tableHeight: window.innerHeight*.8, //表格动态高度
            senderinfoList:[],//列表信息
            addSenderDlog:false,//新增寄件方弹框
            operate:'',//操作   
            pageSize: 30, // 每页展示的条数
            currentPage: 1, // 当前请求的页数
            pagebBean: {
                totalnum: 0,
            }, // 获取到的列表分页信息     
            senderId:'',//寄件方id   
            senderStatus:'',//寄件方状态    
        }
    },

    //   *********************************************************************方法
    methods: { 
        //获取列表信息
        getSenderinfoList() {
            let params = {
                keywords:this.searchClsForm.keywords,
                status:this.searchClsForm.status[0]? Number(this.searchClsForm.status[0]) : '',
                sendermob:this.searchClsForm.sendermob,
                affiliationcode:0,
                pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
                    isnewcomp: 1 //是否需要重新统计页数
                }
            }
            if(this.searchClsForm.bdefault){
                params.bdefault = Number(this.searchClsForm.bdefault)
            }
            this.vloading = true;
            api.GET_SENDERINFOLIST(params).then((res) => {
                if(res.data.status == "200"){
                    this.vloading = false;
                    this.senderinfoList = res.data.data;
                    if(res.data.pagebean){
                        this.pagebBean = res.data.pagebean
                    }
                }
            })
        },
        // 接收分页信息
        updatePage(size,num) {
            this.pageSize = size;
            this.currentPage = num;
            this.getSenderinfoList();
        },
        // 检索的合作状态
        purposeUpdate() {
            if(this.searchClsForm.status.length>1) {
                this.searchClsForm.status.splice(0,1)
            }
            this.currentPage = 1;
            this.getSenderinfoList();
        },
        //查看/编辑寄件方
        getShowDlog(operate,id,status){
            status = status ? 1 : 0;
            this.operate = operate;
            this.senderId = id;
            this.senderStatus = status;
            this.addSenderDlog = true
        },
        //关闭寄件方弹框
        getCloseDlog(done){
            if(done == 1) {
                this.searchClsForm.keywords = '';
                this.searchClsForm.sendermob = '';
                this.searchClsForm.bdefault = '';
                this.searchClsForm.status = [];
                this.currentPage = 1;
                this.getSenderinfoList();
            }
            this.addSenderDlog = false 
        },
        //修改状态
        updSenderinfoStatus(row,val){
            let valTxt = '';
            let status = 0;
            if(!val){
                valTxt = '启用';
                status = 1;
            }else{
                valTxt = '禁用';
                status = 0;
            }
            this.$confirm(`确定要${valTxt}该寄件方吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    id:row.id,
                    status:status
                }
                api.UPDSENDERINFOSTATUS(params).then((res) => {
                    if(res.data.status == '200'){
                        this.$message.success(`${valTxt}成功`);
                        this.getSenderinfoList()
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {});
        },
     
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.lev1Table.$el.offsetTop; //顶部检索条件占据的高度
            this.tableHeight = window.innerHeight - tbHeight - 120; 
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    //   *********************************************************************初始化
    mounted(){
        //在dom渲染之后
        // //取节点,,暂不用
        // setTimeout(()=>{
        // document.querySelectorAll(".cell")[3].title= "点击排序";
        // },1000)
        setTimeout(()=>{
            this.getHeight();
        },200)
        this.getSenderinfoList();// 获取列表信息
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }

}
</script>
<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.textHidenP {margin-right: 50px; max-width: 500px;}
/* .searchForm {padding-top: 64px;} */
.w200{width:200px;} 
.addSenderDlog >>> .el-cascader {width: 100%;}
.addSenderDlog >>> .el-dialog {width: 1000px;}
.comTable >>> .el-tag {display:inline-block;height: 16px; padding: 0 2px;line-height: 14px; font-size: 12px;}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/SysConfiguration/OrdConfiguration/SenderInfo.vue